import { render, staticRenderFns } from "./cadastro_primeiro_pet.vue?vue&type=template&id=77b52194"
import script from "./cadastro_primeiro_pet.vue?vue&type=script&lang=js"
export * from "./cadastro_primeiro_pet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports